import styled from 'styled-components';

const ExceptionWrap = styled.div`
  height: 100%;
  display: flex;
  flex-flow: column nowrap;
`;

export default ExceptionWrap;
